import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "caret-down.icon",
  "use": "caret-down.icon-usage",
  "viewBox": "0 0 1792 1792",
  "content": "<symbol viewBox=\"0 0 1792 1792\" xmlns=\"http://www.w3.org/2000/svg\" id=\"caret-down.icon\">\n    <path d=\"M1408 704q0 26-19 45l-448 448q-19 19-45 19t-45-19L403 749q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol